import { Form, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';

import { fetchTaxes, updateTax } from 'services';
import { getTaxes } from 'store';
import { useFetchSelector, useLegalEntities } from 'hooks';
import { AntSelect } from 'components/common';
import { TaxRate } from 'types';

import { useTaxesTableColumns, useTableActionsColumn, useTableForm } from './hooks';
import { useUpdateSettings } from './hooks/use-update-settings';
import style from './AntSelectFilter.module.scss';

export const TaxesPage = () => {
  const taxes = useFetchSelector<TaxRate[]>(getTaxes, fetchTaxes);
  const { update, loading } = useUpdateSettings(updateTax);
  const { t } = useTranslation();
  const legalEntities = useLegalEntities();
  const [entity, setEntity] = useState('ITR-BEL');

  const { form, isEditing, save, edit, cancel } = useTableForm<TaxRate>(taxes, (tax) => tax.compensationType, update);
  const formActionsColumn = useTableActionsColumn(loading, isEditing, save, edit, cancel);
  const columns = useTaxesTableColumns(loading, isEditing, formActionsColumn);

  const filteredTaxes: TaxRate[] = useMemo(() => {
    return taxes.filter((item: TaxRate) => item.legalEntity === entity);
  }, [entity, taxes]);

  return (
    <Form form={form} component={false}>
      <AntSelect
        allowClear={false}
        formItemProps={{ label: t('byEntity'), className: `${style.antSelectFilter}` }}
        value={entity}
        options={legalEntities}
        className={style.antSelect}
        onChange={(filter: string) => setEntity(filter)}
      />
      <Table dataSource={filteredTaxes} columns={columns} rowKey="compensationType" pagination={false} />
    </Form>
  );
};
